import { namespace } from 'vuex-class';
import { IDisconnectResourceState } from '@/content-library/disconnect-resource/store/disconnect-resource.types';

export const DisconnectResource = namespace('contentLibrary/disconnectResource');

export const state: IDisconnectResourceState = {
  disconnecting: false,
  newDocumentPage: null,
};

export enum EDisconnectResourceAction {
  Disconnect = 'disconnect',
  DisconnectFailed = 'disconnectFailed',
  UpdatePage = 'updatePage',
  UpdatePageSuccess = 'updatePageSuccess',
  UpdatePageFailed = 'updatePageFailed',
  Reset = 'reset',
}

export enum EDisconnectResourceMutation {
  SetDisconnecting = 'setDisconnecting',
  SetNewDocumentPage = 'setNewDocumentPage',
  SetState = 'setState',
}
